import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import appReducer from "./appReducer";
// import adminReducer from "./adminReducer";
import userReducer from "./userReducer";
import patientReducer from './patientReducer';

import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import ActionAdminReducer from './ActionAdminReducer'
import DoctorReducer from './DoctorReducer';

const persistCommonConfig = {
    storage: storage,
    stateReconciler: autoMergeLevel2,
};

const userPersistConfig = {
    ...persistCommonConfig,
    key: 'user',
    whitelist: ['isLoggedIn', 'userInfo']
};
const patientPersistConfig = {
    ...persistCommonConfig,
    key: 'patient',
    whitelist: ['isLoggedInPatient', 'patientInfo']
};

const appPersistConfig = {
    ...persistCommonConfig,
    key: 'app',
    whitelist: ['language']
}

export default (history) => combineReducers({
    router: connectRouter(history),
    user: persistReducer(userPersistConfig, userReducer),
    patient: persistReducer(patientPersistConfig, patientReducer),
    app: persistReducer(appPersistConfig, appReducer),
    admin: ActionAdminReducer,
    doctor: DoctorReducer,
})